export default __webpack_public_path__ + "static/scroll-01-7dc01e6afdf93ca85ad5f4158eb71736.jpg";